import { LIMITES_PAGINACION_GRID } from '@shared/constants/paginacion';
import { FD_BADGE_VARIANTE, FdBadgeVariante } from '@shared/componentes/fd-badge-estado/fd-badge-estado.constants';
import { ROL_CLIENTE, RolCliente } from '@gestion-cliente/models/rol-cliente.enum';
import { PESTANA_FICHA, PestanaFicha } from '@gestion-cliente/models/pestana-ficha.enum';

export const ENDPOINTS_GESTION_CLIENTE = {
  BUSCAR: 'gestion-clientes',
  MI_ORGANIZACION: 'gestion-clientes/mi-organizacion',
  INFORMACION_BASICA_MI_ORGANIZACION: 'gestion-clientes/mi-organizacion/informacion-basica',
  ficha: (clienteId: string): string => `gestion-clientes/${clienteId}`,
  informacionBasica: (clienteId: string): string => `gestion-clientes/${clienteId}/informacion-basica`
} as const;

export const RUTAS_GESTION_CLIENTE = {
  BUSQUEDA: '/configuracion/gestion-cliente',
  MI_ORGANIZACION: '/configuracion/gestion-cliente/mi-organizacion',
  ficha: (clienteId: string): string => `/configuracion/gestion-cliente/${clienteId}`
} as const;

export const PESTANA_POR_ROL: Readonly<Record<RolCliente, PestanaFicha>> = {
  [ROL_CLIENTE.EMISOR]: PESTANA_FICHA.EMISOR,
  [ROL_CLIENTE.DEUDOR]: PESTANA_FICHA.DEUDOR,
  [ROL_CLIENTE.FONDEADOR]: PESTANA_FICHA.FONDEADOR
};

export const VARIANTE_ESTADO_CLIENTE: Readonly<Record<string, FdBadgeVariante>> = {
  ['Activo']: FD_BADGE_VARIANTE.GREEN,
  ['Vinculado']: FD_BADGE_VARIANTE.GREEN,
  ['En Proceso de Vinculación']: FD_BADGE_VARIANTE.BLUE,
  ['Prospecto']: FD_BADGE_VARIANTE.BLUE,
  ['Vencido']: FD_BADGE_VARIANTE.AMBER,
  ['Inactivo']: FD_BADGE_VARIANTE.NEUTRAL,
  ['No Interesado']: FD_BADGE_VARIANTE.NEUTRAL,
  ['Descartado']: FD_BADGE_VARIANTE.NEUTRAL,
  ['Negado']: FD_BADGE_VARIANTE.RED,
  ['Cupo negado']: FD_BADGE_VARIANTE.RED
};

export const LOGO_CLIENTE = {
  TAMANO_MAXIMO_BYTES: 512_000,
  TIPOS_PERMITIDOS: ['image/png', 'image/jpeg'],
  ACCEPT: 'image/png,image/jpeg'
} as const;

export const VALIDACION_INFORMACION_BASICA = {
  LONGITUD_CIUDAD: 100,
  LONGITUD_TELEFONO: 50,
  LONGITUD_EMAIL: 100,
  LONGITUD_DIRECCION: 300,
  PATRON_TELEFONO: /^\+?[0-9 ()-]{7,20}$/
} as const;

export const PATRON_BUSQUEDA_POR_NIT = /^[\d.\s-]+$/;

export const ICONOS_ACCION_FILA_CLIENTE = {
  EDITAR: 'pi pi-pencil',
  ELIMINAR: 'pi pi-trash',
  INACTIVAR: 'pi pi-ban',
  ACTIVAR: 'pi pi-check-circle'
} as const;

export const ICONO_GESTIONAR_CLIENTE = 'assets/svg/icon-gestionar.svg';

export const PAGINACION_BUSQUEDA_CLIENTE = {
  PAGINA_INICIAL: 1,
  TAMANO_PAGINA: LIMITES_PAGINACION_GRID.DEFAULT,
  OPCIONES_TAMANO: LIMITES_PAGINACION_GRID.OPCIONES
} as const;

export const MENSAJES_GESTION_CLIENTE = {
  TITULO_BUSQUEDA: 'Gestión de cliente',
  DESCRIPCION_BUSQUEDA: 'Busque por nombre o NIT el cliente que quiere configurar, o seleccione uno de la lista.',
  PLACEHOLDER_VALOR_BUSQUEDA: 'Ej: Productos Familia o 900123456',
  BOTON_GESTIONAR: 'Gestionar',
  TITULO_RESULTADOS: 'Resultados',
  SIN_RESULTADOS: 'No se encontraron clientes con los criterios indicados',
  SIN_RESULTADOS_DETALLE: 'Verifique el nombre o el NIT e inténtelo de nuevo.',
  ERROR_BUSQUEDA: 'No fue posible consultar los clientes. Intente de nuevo.',
  COLUMNA_CODIGO: 'Código',
  COLUMNA_NOMBRE: 'Nombre',
  COLUMNA_NIT: 'NIT',
  COLUMNA_ROLES: 'Roles',
  COLUMNA_LINEAS: 'Tipos de negocio',
  COLUMNA_ACCIONES: 'Gestionar',
  tooltipGestionar: (nombre: string): string => `Gestionar ${nombre}`,
  chipBusqueda: (valor: string): string => `Búsqueda: ${valor}`,
  resultadosEncontrados: (total: number): string =>
    total === 1 ? '1 cliente encontrado' : `${total} clientes encontrados`,
  BOTON_VOLVER: 'Volver a la lista de clientes',
  CARGANDO_FICHA: 'Cargando la información del cliente…',
  ERROR_FICHA: 'No fue posible cargar la información del cliente.',
  ETIQUETA_NIT: 'NIT',
  ETIQUETA_ADMINISTRADOR: 'Administrador de la organización',
  SIN_ADMINISTRADOR: 'Sin administrador asignado',
  TITULO_LINEAS: 'Tipos de negocio',
  SIN_LINEAS: 'Sin tipos de negocio activos',
  ETIQUETA_CUPO: 'Cupo',
  SIMBOLO_MONEDA: '$',
  ETIQUETA_VENCE: 'Vence',
  SIN_FECHA_VENCIMIENTO: 'Sin fecha',
  ARIA_PESTANAS: 'Secciones de la ficha',
  PESTANA_INFORMACION_BASICA: 'Información básica',
  PESTANA_EMISOR: 'Emisor',
  PESTANA_DEUDOR: 'Deudor',
  PESTANA_FONDEADOR: 'Fondeador',
  ETIQUETA_LOGO: 'Logo de la empresa',
  ALT_LOGO: 'Logo del cliente',
  LOGO_PREVISUALIZACION: 'Previsualización',
  BOTON_CAMBIAR_LOGO: 'Cambiar logo',
  BOTON_QUITAR_LOGO: 'Quitar',
  AYUDA_LOGO: 'PNG o JPG · máx. 500 KB',
  LOGO_FORMATO_INVALIDO: 'Formato no permitido. Solo se admiten imágenes PNG o JPG.',
  LOGO_EXCEDE_TAMANO: 'El archivo supera los 500 KB permitidos.',
  ETIQUETA_CIUDAD: 'Ciudad',
  ETIQUETA_TELEFONO: 'Teléfono',
  ETIQUETA_EMAIL: 'Email',
  ETIQUETA_DIRECCION: 'Dirección',
  ETIQUETA_DV: 'Dígito de verificación',
  PLACEHOLDER_TELEFONO: '+57 (601) 555 0000',
  AYUDA_TELEFONO: 'Formato: +57 (CCC) XXX XXXX',
  CAMPO_REQUERIDO: 'Campo obligatorio',
  EMAIL_INVALIDO: 'Debe ser un correo electrónico válido',
  TELEFONO_INVALIDO: 'Solo números, espacios, paréntesis, guiones y el prefijo +',
  longitudExcedida: (maximo: number): string => `Máximo ${maximo} caracteres`,
  NOTA_GUARDADO_SECCION: 'Los cambios se guardan por sección; no se mezclan con otras pestañas.',
  CAMBIOS_SIN_GUARDAR_BANNER: 'Tienes cambios sin guardar en Información básica.',
  BOTON_GUARDAR: 'Guardar',
  BOTON_CANCELAR: 'Cancelar',
  GUARDADO_EXITOSO: 'Información actualizada correctamente',
  CORREGIR_CAMPOS: 'Corrige los campos en error antes de guardar.',
  TITULO_CAMBIOS_SIN_GUARDAR: 'Cambios sin guardar',
  DETALLE_CAMBIOS_SIN_GUARDAR: 'Estás por dejar la pestaña Información básica con cambios sin guardar. Si continúas, se perderán.',
  BOTON_SEGUIR_EDITANDO: 'Seguir editando',
  BOTON_DESCARTAR_Y_SALIR: 'Descartar y salir'
} as const;
